import React from 'react';
import { Icon } from './Icon.js';
export const IconBookOpen2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 6V21", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2 4L12 6L22 4V19L12 21L2 19V4Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconBookOpen2.js.map